import ValueChain from "../ValueChain";

interface textConfidentialProps {
  label: string;
  textValid: boolean;
  textValue: string;
  textName: string;
  onChange: (e: any) => void;
  isMandatory: boolean;
  display: boolean;
}

function TextNoConfidential({
  label,
  textName,
  textValid = true,
  textValue,
  onChange,
  isMandatory = false,
  display,
}: textConfidentialProps) {
  return (
    <div className={display ? "hidden-content" : "visible-content"}>
      <div className="form-group">
        <label className="control-label">{label}</label>
        <div className="text-area-noconfidential-container">
          {isMandatory ? (
            <textarea
              className={textValid ? "form-control" : "form-control is-invalid"}
              value={textValue}
              name={textName}
              onChange={onChange}
              maxLength={1500}
            />
          ) : (
            <textarea
              className="form-control"
              value={textValue}
              name={textName}
              onChange={onChange}
              maxLength={1500}
            />
          )}
          <div
            className={
              textValue.length == 1500
                ? "char-counter-no-conf error-text-important"
                : "char-counter-no-conf"
            }
          >
            {textValue.length}/1500
          </div>
        </div>
      </div>
    </div>
  );
}

export default TextNoConfidential;
